// import './bootstrap';
import '@material-ui/styles'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { loadProgressBar } from 'axios-progress-bar'
import axios from 'axios';

 
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import QueryProvider from './lib/query/QueryProvider';

loadProgressBar()


  ReactDOM.render( 
    <QueryProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </QueryProvider>, 
  document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
axios.defaults.withCredentials = true;